import React from 'react';
import { Download, Printer, Package, Truck } from 'lucide-react';

const ShippingLabel = ({ transaction }) => {
  if (!transaction.shippingLabel || !transaction.shippingLabel.labelUrl) {
    return null;
  }

  const { shippingLabel } = transaction;

  const handleDownloadLabel = () => {
    window.open(shippingLabel.labelUrl, '_blank');
  };

  const handlePrintLabel = () => {
    const printWindow = window.open(shippingLabel.labelUrl, '_blank');
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.print();
      };
    }
  };

  return (
    <div
      style={{
        padding: '20px',
        background: 'linear-gradient(135deg, var(--primary) 0%, var(--primaryDark) 100%)',
        color: 'white',
        borderRadius: '12px',
        marginBottom: '20px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
        <Package size={32} />
        <div>
          <h3 style={{ margin: 0, fontSize: '20px' }}>Shipping Label Ready</h3>
          <p style={{ margin: '4px 0 0', opacity: 0.9, fontSize: '14px' }}>
            {shippingLabel.carrier} {shippingLabel.servicelevel}
          </p>
        </div>
      </div>

      {transaction.trackingNumber && (
        <div
          style={{
            padding: '12px',
            background: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '8px',
            marginBottom: '16px',
          }}
        >
          <div style={{ fontSize: '12px', opacity: 0.9, marginBottom: '4px' }}>Tracking Number</div>
          <div style={{ fontSize: '18px', fontWeight: '700', fontFamily: 'monospace' }}>
            {transaction.trackingNumber}
          </div>
          {shippingLabel.trackingUrlProvider && (
            <a
              href={shippingLabel.trackingUrlProvider}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: 'white',
                fontSize: '14px',
                textDecoration: 'underline',
                marginTop: '8px',
                display: 'inline-block',
              }}
            >
              Track Package <Truck size={14} style={{ display: 'inline', marginLeft: '4px' }} />
            </a>
          )}
        </div>
      )}

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
        <button
          onClick={handleDownloadLabel}
          style={{
            flex: 1,
            minWidth: '200px',
            padding: '12px 20px',
            background: 'white',
            color: 'var(--primary)',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
        >
          <Download size={20} />
          Download Label PDF
        </button>

        <button
          onClick={handlePrintLabel}
          style={{
            flex: 1,
            minWidth: '200px',
            padding: '12px 20px',
            background: 'rgba(255, 255, 255, 0.2)',
            color: 'white',
            border: '2px solid white',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
        >
          <Printer size={20} />
          Print Label
        </button>
      </div>

      {shippingLabel.labelCost && (
        <div style={{ marginTop: '12px', fontSize: '14px', opacity: 0.9, textAlign: 'center' }}>
          Label cost: ${shippingLabel.labelCost.toFixed(2)} (paid by buyer)
        </div>
      )}
    </div>
  );
};

export default ShippingLabel;
